import { render, staticRenderFns } from "./tabbed-toggle.vue?vue&type=template&id=8a883cca&scoped=true&lang=pug&"
import script from "./tabbed-toggle.vue?vue&type=script&lang=js&"
export * from "./tabbed-toggle.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-toggle.vue?vue&type=style&index=0&id=8a883cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a883cca",
  null
  
)

export default component.exports